import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Dots } from "@zendeskgarden/react-loaders";

import styles from "./styles.css";

export default class LoaderPanel extends PureComponent {
  static propTypes = {
    testId: PropTypes.string,
    delayMS: PropTypes.number,
  };

  render() {
    const { delayMS, testId } = this.props;

    return (
      <div className={styles.loader}>
        <Dots delayMS={delayMS} data-test-id={testId} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoaderPanel/index.js